import Vue from "vue";
import __dayjs from "dayjs";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

__dayjs.extend(utc);
__dayjs.extend(timezone);
__dayjs.locale("ko");
__dayjs.tz.setDefault("Asia/Seoul");

export const dayjs = __dayjs;
export default dayjs;

/**
 * @param {Vue} Vue
 * @param {*} options
 */
const install = function(Vue, options) {
    Vue.prototype.$dayjs = dayjs;
};

Vue.use({ install });
